module.exports = __webpack_public_path__ + "img/grid-tracker.f5627216.png";